import { render } from "./notes-list.vue?vue&type=template&id=2d0447ae&scoped=true"
import script from "./notes-list.vue?vue&type=script&lang=js"
export * from "./notes-list.vue?vue&type=script&lang=js"

import "./notes-list.vue?vue&type=style&index=0&id=2d0447ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0447ae"]])

export default __exports__